import { formatNumber } from "@/lib/format";

const qtyTxt = (m) => (m.remaining_koli != null ? `${formatNumber(m.remaining_koli)} koli${m.remaining_adet ? ` + ${formatNumber(m.remaining_adet)} adet` : ""} (${formatNumber(m.remaining_qty)})` : formatNumber(m.remaining_qty));

export const ProductMatches = ({ row, onOpen }) => (
  <div className="flex flex-wrap gap-2" data-testid={`import-matches-${row.file_no}`}>
    <span className="self-center text-[11px] font-semibold uppercase tracking-wider text-slate-500">Bulunan ürünler</span>
    {row.matches.map((m) => (
      <button key={m.line_id} type="button" onClick={(e) => { e.stopPropagation(); onOpen(m.line_id); }} data-testid={`import-match-${row.file_no}-${m.sku}`}
        className="flex items-center gap-2 rounded border border-slate-200 bg-white px-2 py-1 text-left text-[12px] transition-colors hover:border-blue-400 hover:bg-blue-50">
        {m.image_url ? <img src={m.image_url} alt="" className="h-8 w-8 rounded object-cover" /> : <div className="h-8 w-8 rounded bg-slate-100" />}
        <div>
          <div><span className="font-mono font-semibold">{m.sku}</span> {m.name}
            {m.pending_product && <span className="ml-1 rounded bg-violet-100 px-1.5 py-0.5 text-[10px] font-semibold text-violet-700">Yeni ürün</span>}</div>
          <div className="text-[11px] text-slate-500">Beklenen {formatNumber(m.expected_qty)} · Kabul {formatNumber(m.received_qty)} · Kalan <b className="text-slate-800">{qtyTxt(m)}</b>
            {" · "}{m.status_label}{m.po_no && <> · <span className="font-mono">{m.po_no}</span></>}</div>
        </div>
      </button>
    ))}
  </div>
);

export const MatchSummary = ({ s, q }) => (
  <div className="border-b border-blue-200 bg-blue-50 px-3 py-2 text-[13px]" data-testid="imports-product-summary">
    <b>"{q}"</b> ürünü <b>{s.containers}</b> konteynerde: toplam beklenen <b className="font-mono">{formatNumber(s.expected)}</b>, kalan <b className="font-mono">{formatNumber(s.remaining)}</b>
    {Object.entries(s.by_status).map(([k, v]) => <span key={k}> · {v.label}: <b className="font-mono">{formatNumber(v.remaining)}</b> ({v.containers})</span>)}
  </div>
);
